import { motion } from "framer-motion";
import { MapPin, RefreshCw, Star } from "lucide-react";
import { Button } from "../ui/button";
import ForecastTrustScore from "../ForecastTrustScore";

export function CurrentWeatherCard({
  item,
  location,
  weather,
  fetchWeather,
  loading,
  isLocationSaved,
  saveLocation,
  WeatherIcon,
  convertTemp,
}) {
  return (
    <motion.div
      variants={item}
      className="col-span-1 md:col-span-2 row-span-2 glass rounded-3xl p-4 md:p-6 lg:p-8 relative overflow-hidden group"
      data-testid="current-weather-card"
    >
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#00f2ea]/5 rounded-full blur-3xl pointer-events-none" />

      <div className="flex justify-between items-start mb-4">
        <div>
          <div className="flex items-center gap-2 text-white/60 mb-1">
            <MapPin className="w-4 h-4" />
            <span className="text-sm font-medium">{location?.name}</span>
          </div>
          <p className="text-sm text-white/40">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
            })}
          </p>
          {location && (
            <div className="mt-2" data-testid="current-weather-trust-score-container">
              <ForecastTrustScore lat={location.lat} lon={location.lon} />
            </div>
          )}
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="icon" onClick={() => location && fetchWeather(location.lat, location.lon)} data-testid="refresh-weather-btn" className="rounded-xl hover:bg-white/10">
            <RefreshCw className={`w-5 h-5 ${loading ? "animate-spin" : ""}`} />
          </Button>
          <Button variant="ghost" size="icon" onClick={isLocationSaved ? undefined : saveLocation} data-testid="save-location-btn" className={`rounded-xl ${isLocationSaved ? "text-[#ccff00]" : "hover:bg-white/10"}`}>
            {isLocationSaved ? <Star className="w-5 h-5 fill-current" /> : <Star className="w-5 h-5" />}
          </Button>
        </div>
      </div>

      {weather && (
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
          <div className="weather-icon-float">
            <WeatherIcon code={weather.weather[0].icon} size={120} />
          </div>
          <div className="text-center md:text-left">
            <div className="text-7xl md:text-8xl font-black tracking-tighter gradient-text-cyan">
              {convertTemp(weather.main.temp)}°
            </div>
            <p className="text-xl capitalize text-white/80 mt-2">{weather.weather[0].description}</p>
            <p className="text-sm text-white/50 mt-1">
              H: {convertTemp(weather.main.temp_max)}° L: {convertTemp(weather.main.temp_min)}°
            </p>
            <p className="text-base mt-1">
              Feels like <span className="gradient-text-cyan font-semibold">{convertTemp(weather.main.feels_like)}°</span>
            </p>
          </div>
        </div>
      )}
    </motion.div>
  );
}